import { useQuery } from '@tanstack/react-query';
import { type Branding, DEFAULT_BRANDING } from '../branding';
export function useBranding() {
  const { data } = useQuery({
    queryKey: ['branding'],
    queryFn: async (): Promise<Branding> => {
      const response = await fetch('/api/branding');
      if (!response.ok) throw new Error('Branding unavailable');
      const value = await response.json();
      const png = (data: unknown) =>
        typeof data === 'string' && data.startsWith('data:image/png;base64,') ? data : null;
      // The assistant's name and icon stand on their own, with or without a company name.
      const assistant = {
        assistantName:
          typeof value?.assistantName === 'string' && value.assistantName.trim()
            ? value.assistantName.trim().slice(0, 24)
            : null,
        assistantIconDataUrl: png(value?.assistantIconDataUrl),
      };
      return typeof value?.companyName === 'string'
        ? { companyName: value.companyName, logoDataUrl: png(value.logoDataUrl), ...assistant }
        : { ...DEFAULT_BRANDING, ...assistant };
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: false,
  });
  return data ?? DEFAULT_BRANDING;
}
